export interface Coordinates {
  latitude: number;
  longitude: number;
}

interface LocatedRestaurant {
  id: string;
  name: string;
  gps_lat?: number | null;
  gps_lng?: number | null;
}

export function distanceKm(origin: Coordinates, latitude?: number | null, longitude?: number | null): number {
  if (latitude == null || longitude == null || !Number.isFinite(latitude) || !Number.isFinite(longitude)
    || Math.abs(latitude) > 90 || Math.abs(longitude) > 180 || (latitude === 0 && longitude === 0)) {
    return Infinity;
  }
  const radians = (degrees: number) => degrees * Math.PI / 180;
  const latDelta = radians(latitude - origin.latitude);
  const lonDelta = radians(longitude - origin.longitude);
  const a = Math.sin(latDelta / 2) ** 2 + Math.cos(radians(origin.latitude))
    * Math.cos(radians(latitude)) * Math.sin(lonDelta / 2) ** 2;
  return 6371 * 2 * Math.asin(Math.sqrt(Math.min(1, Math.max(0, a))));
}

export function sortRestaurantsByDistance<T extends LocatedRestaurant>(restaurants: T[], origin: Coordinates): T[] {
  const distances = new Map(restaurants.map(r => [r.id, distanceKm(origin, r.gps_lat, r.gps_lng)]));
  return [...restaurants].sort((a, b) => {
    const left = distances.get(a.id) ?? Infinity;
    const right = distances.get(b.id) ?? Infinity;
    return (left === right ? 0 : left - right) || a.name.localeCompare(b.name, 'hu');
  });
}